import { render, staticRenderFns } from "./campaignActionsButton.vue?vue&type=template&id=0548ee8a&scoped=true&"
import script from "./campaignActionsButton.vue?vue&type=script&lang=js&"
export * from "./campaignActionsButton.vue?vue&type=script&lang=js&"
import style0 from "./campaignActionsButton.vue?vue&type=style&index=0&id=0548ee8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0548ee8a",
  null
  
)

export default component.exports